module.exports = __webpack_public_path__ + "static/img/501.fce0ec2.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/productSpring/images/501.png
// module id = 530
// module chunks = 3